<template>
  <div>
    <div v-if="currentFiles">
      <div>
        <v-progress-linear
          v-model="progress"
          color="light-blue"
          height="25"
          reactive
        >
          <strong>{{ progress }} %</strong>
        </v-progress-linear>
      </div>
    </div>

    <v-row align="center" v-if="!readOnly">
      <v-col cols="12" lg="5">
        <v-file-input
          class="mr-4 ml-2"
          show-size
          :label="$t('file.select')"
          @change="selectFile"
        ></v-file-input>
      </v-col>
      <v-col cols="6" sm="5" lg="3">
        <v-select
          class="ml-4"
          :label="$t('file.type')"
          :items="fileTypes"
          item-value="value"
          item-text="text"
          v-model="fileType"
        />
      </v-col>
      <v-col cols="6" sm="3" md="3" lg="2" class="pl-5 without-padding-top">
        <v-checkbox
          class="big"
          :label="$t('file.public')"
          v-model="public_pub"
        />
      </v-col>

      <v-col cols="2" class="">
        <v-btn color="success" dark small @click="upload">
          {{ $t("button.upload") }}
          <v-icon right dark>mdi-cloud-upload</v-icon>
        </v-btn>
      </v-col>
    </v-row>

    <v-alert v-if="message" border="left" color="blue-grey" dark>
      {{ message }}
    </v-alert>

    <v-simple-table class="border-box">
      <template v-slot:default>
        <thead>
          <tr>
            <th class="text-left">{{ $t("file.type") }}</th>
            <th class="text-left">{{ $t("file.name") }}</th>
            <th class="text-left">{{ $t("file.public") }}</th>
            <th class="text-left"></th>
          </tr>
        </thead>
        <tr v-for="(item, index) in fileInfos" :key="index" class="text-left">
          <td>{{ $t("file.types." + item.type) }}</td>
          <td>
            <a :href="$store.state.endpoint + item.file" target="_blank">{{
              item.name
            }}</a>
          </td>
          <td>
            <v-checkbox
              v-if="!readOnly"
              class="my-0"
              hide-details
              :input-value="item.public"
              :disabled="isUpdatingPublic(item.id)"
              :loading="isUpdatingPublic(item.id)"
              @change="updatePublicFlag(item, $event)"
            />
            <template v-else>
              <v-icon v-if="item.public" color="green">mdi-check-circle</v-icon>
              <v-icon v-else color="red">mdi-close-circle</v-icon>
            </template>
          </td>
          <td>
            <v-icon :disabled="readOnly" color="red" @click="deleteFile(item)">
              mdi-delete
            </v-icon>
          </td>
        </tr>
      </template>
    </v-simple-table>
  </div>
</template>

<script>
import UploadService from "../../plugins/uploadFiles";
import axios from "axios";

export default {
  name: "upload-files",
  props: {
    id: Number,
    final: Boolean,
    object_type: String,
    readOnly: Boolean
  },
  data() {
    return {
      fileType: undefined,
      public_pub: false,
      fileTypes: [],
      currentFiles: undefined,
      progress: 0,
      message: "",

      fileInfos: [],
      changingPublic: {}
    };
  },

  created() {
    this.getFiles();
  },

  watch: {
    id() {
      this.getFiles();
    }
  },
  methods: {
    getFiles() {
      if (this.id !== null) {
        this.getFileTypes();
        UploadService.getFiles(this.id, this.final, this.object_type).then(response => {
          this.fileInfos = response.data;
          this.$emit(
            "get-files",
            response.data.map(item => item.id)
          );
        });
      }
    },
    getFileTypes() {
      let path = undefined
      if (this.object_type === 'publication'){
        path = this.$store.state.endpoint + "/utils/fileTypes";
      } else if (this.object_type === 'news'){
        path = this.$store.state.endpoint + "/utils/newsFiles";
      } else if (this.object_type === 'industrial_property'){
        path = this.$store.state.endpoint + "/utils/industrialPropertyFiles";
      } else {
        path = this.$store.state.endpoint + "/utils/projectFiles";
      }

      axios
        .get(path)
        .then(response => {
          response.data.forEach(item => {
            this.fileTypes.push({
              text: this.$t("file.types." + item),
              value: item
            });
            if (this.fileTypes.length) this.fileType = this.fileTypes[0].value;
          });
        })
        .catch(error => {
          console.log(error);
        });
    },
    selectFile(files) {
      this.progress = 0;
      this.currentFiles = files;
    },
    upload() {
      if (!this.currentFiles) {
        this.message = this.$t("message.error.noFile");
        return;
      }
      if (!this.fileType) {
        this.message = this.$t("message.error.noType");
        return;
      }

      if (this.currentFiles.name.length > 100){
        this.message = this.$t("message.error.maxLength");
        return;
      }

      this.message = "";

      UploadService.upload(
        this.id,
        this.final,
        this.object_type,
        this.fileType,
        this.public_pub,
        this.currentFiles,
        event => {
          this.progress = Math.round((100 * event.loaded) / event.total);
        }
      )
        .then(response => {
          this.message = response.data.message;
          return UploadService.getFiles(this.id, this.final, this.object_type);
        })
        .then(files => {
          this.$store.commit("alert", {
            color: "success",
            text: this.$t("message.correct.uploadFile") + this.currentFiles.name
          });
          this.fileInfos = files.data;
          this.$emit(
            "change-files",
            files.data.map(item => item.id)
          );
        })
        .catch(() => {
          this.progress = 0;
          this.message =
            this.$t("message.error.uploadFile") + this.currentFiles.name;
          this.currentFiles = undefined;
        });
    },

    deleteFile(file) {
      UploadService.deleteFile(file.id, this.object_type)
        .then(response => {
          return UploadService.getFiles(this.id, this.final, this.object_type);
        })
        .then(files => {
          this.$store.commit("alert", {
            color: "success",
            text: this.$t("message.correct.deleteFile") + file.name
          });
          this.fileInfos = files.data;
          this.$emit(
            "change-files",
            files.data.map(item => item.id)
          );
        })
        .catch(() => {
          this.$store.commit("alert", {
            color: "error",
            text: this.$t("message.error.deleteFile") + file.name
          });
        });
    },
    isUpdatingPublic(fileId) {
      return !!this.changingPublic[fileId];
    },
    updatePublicFlag(item, value) {
      if (this.readOnly) {
        return;
      }
      const nextValue = Boolean(value);
      if (item.public === nextValue) {
        return;
      }
      if (!this.final && (this.id === null || this.id === undefined)) {
        this.$store.commit("alert", {
          color: "error",
          text: this.$t("message.error.updateFilePublic", { file: item.name })
        });
        return;
      }
      const previous = item.public;
      this.$set(this.changingPublic, item.id, true);
      this.$set(item, "public", nextValue);
      UploadService.updateFilePublic(
        this.id,
        this.final,
        this.object_type,
        item.id,
        nextValue
      )
        .then(() => {
          this.$store.commit("alert", {
            color: "success",
            text: this.$t("message.correct.updateFilePublic", {
              file: item.name
            })
          });
          this.$emit(
            "change-files",
            this.fileInfos.map(file => file.id)
          );
        })
        .catch(() => {
          this.$set(item, "public", previous);
          this.$store.commit("alert", {
            color: "error",
            text: this.$t("message.error.updateFilePublic", {
              file: item.name
            })
          });
        })
        .finally(() => {
          this.$delete(this.changingPublic, item.id);
        });
    }
  }
};
</script>
